import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { PortfolioPage } from './pages/PortfolioPage';
import { HowWeInvestPage } from './pages/HowWeInvestPage';
import { HowWeHelpPage } from './pages/HowWeHelpPage';
import { TeamPage } from './pages/TeamPage';
import { TeamMemberPage } from './pages/TeamMemberPage';
import { InsightsPage } from './pages/InsightsPage';
import { ThemeProvider } from './contexts/ThemeContext';
export function App() {
  return <ThemeProvider data-id="element-0">
      <BrowserRouter data-id="element-1">
        <div className="flex flex-col min-h-screen bg-white text-[#070707] transition-colors" data-id="element-2">
          <Navbar data-id="element-3" />
          <main className="flex-grow" data-id="element-4">
            <Routes data-id="element-5">
              <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
              <Route path="/companies" element={<PortfolioPage data-id="element-9" />} data-id="element-8" />
              <Route path="/how-we-invest" element={<HowWeInvestPage data-id="element-11" />} data-id="element-10" />
              <Route path="/how-we-help" element={<HowWeHelpPage data-id="element-13" />} data-id="element-12" />
              <Route path="/team" element={<TeamPage data-id="element-15" />} data-id="element-14" />
              <Route path="/team/:slug" element={<TeamMemberPage data-id="element-17" />} data-id="element-16" />
              <Route path="/insights" element={<InsightsPage data-id="element-19" />} data-id="element-18" />
            </Routes>
          </main>
          <Footer data-id="element-20" />
        </div>
      </BrowserRouter>
    </ThemeProvider>;
}